import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface AccordionItemProps {
  emoji: string;
  title: string;
  badge?: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
}
export function AccordionItem({
  emoji,
  title,
  badge,
  defaultOpen = false,
  children
}: AccordionItemProps) {
  const [open, setOpen] = useState(defaultOpen);
  return <div className="overflow-hidden rounded-2xl border border-white/20 bg-[#101b2d]/95 shadow-lg shadow-black/20 backdrop-blur-md" data-id="element-16">
      <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} aria-label={`${open ? 'Collapse' : 'Expand'} ${title}`} className="flex w-full items-center gap-3 px-4 py-4 text-left" data-id="element-17">
        <span className="text-2xl leading-none" aria-hidden data-id="element-18">
          {emoji}
        </span>
        <span className="flex-1" data-id="element-19">
          <span className="block font-display text-base font-700 leading-tight text-white" data-id="element-20">
            {title}
          </span>
          {badge && <span className="mt-1 inline-block rounded-full bg-[var(--pb-lime)]/15 px-2 py-0.5 text-xs font-600 text-[var(--pb-lime)]" data-id="element-21">
              {badge}
            </span>}
        </span>
        <motion.span animate={{
        rotate: open ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="shrink-0 text-[var(--pb-lime)]" data-id="element-22">
          <ChevronDownIcon size={22} data-id="element-23" />
        </motion.span>
      </button>
      <AnimatePresence initial={false} data-id="element-24">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: 'easeInOut'
      }} data-id="element-25">
            <div className="px-4 pb-4 pt-0" data-id="element-26">{children}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}